module.exports = __webpack_public_path__ + "static/img/waikuang.d17cf134.png";